import { api } from '../../../servicesGlobais/api'
import type { PerformanceResumo } from '../tipos/performance'

function normalizeLinha(c: any) {
  const rawTk = c.nomesTickets ?? c.NomesTickets
  const nomesTickets = Array.isArray(rawTk) ? rawTk.map((x: unknown) => String(x ?? '')) : []
  return {
    pessoaId: Number(c.pessoaId ?? c.PessoaId ?? 0),
    nome: c.nome ?? c.Nome ?? '',
    nomeTime: c.nomeTime ?? c.NomeTime ?? null,
    minutosEsperados: Number(c.minutosEsperados ?? c.MinutosEsperados ?? 0),
    minutosTrabalhadosClockify: Number(c.minutosTrabalhadosClockify ?? c.MinutosTrabalhadosClockify ?? 0),
    minutosFaturados: Number(c.minutosFaturados ?? c.MinutosFaturados ?? 0),
    horasEsperadas: Number(c.horasEsperadas ?? c.HorasEsperadas ?? 0),
    horasTrabalhadas: Number(c.horasTrabalhadas ?? c.HorasTrabalhadas ?? 0),
    horasFaturadas: Number(c.horasFaturadas ?? c.HorasFaturadas ?? 0),
    percentualTrabalhadoVsEsperado:
      c.percentualTrabalhadoVsEsperado ?? c.PercentualTrabalhadoVsEsperado ?? null,
    percentualFaturadoVsTrabalhado:
      c.percentualFaturadoVsTrabalhado ?? c.PercentualFaturadoVsTrabalhado ?? null,
    nomesTickets,
  }
}

function normalize(raw: any): PerformanceResumo {
  return {
    dataInicio: raw.dataInicio ?? raw.DataInicio ?? '',
    dataFim: raw.dataFim ?? raw.DataFim ?? '',
    diasUteis: Number(raw.diasUteis ?? raw.DiasUteis ?? 0),
    minutosEsperadosPorColaborador: Number(
      raw.minutosEsperadosPorColaborador ?? raw.MinutosEsperadosPorColaborador ?? 0
    ),
    colaboradores: (raw.colaboradores ?? raw.Colaboradores ?? []).map(normalizeLinha),
  }
}

export const performanceService = {
  async obter(dataInicio: string, dataFim: string, idTime?: number): Promise<PerformanceResumo> {
    const params = new URLSearchParams()
    params.append('dataInicio', dataInicio)
    params.append('dataFim', dataFim)
    if (idTime != null && idTime > 0) params.append('idTime', String(idTime))
    const raw = await api.get<any>(`/Performance?${params.toString()}`)
    return normalize(raw)
  },
}
